


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import SvgDiagonalDriversLicense from '@/components/SvgDiagonalDriversLicense.vue';
import SvgDiagonalMyNumberCard from '@/components/SvgDiagonalMyNumberCard.vue';
import SvgDiagonalResidenceCard from '@/components/SvgDiagonalResidenceCard.vue';
// 特別永住者証明書は在留カードと同一の画像コンポーネントを使用
import SvgDiagonalSpecialPermanentResidentCertificate from '@/components/SvgDiagonalResidenceCard.vue';
import SvgDiagonalPassport1 from '@/components/SvgDiagonalPassport1.vue';
import SvgDiagonalPassport2 from '@/components/SvgDiagonalPassport2.vue';
import SvgDiagonalHealthInsuranceCard from '@/components/SvgDiagonalHealthInsuranceCard.vue';
import SvgDiagonalGeneralCard from '@/components/SvgDiagonalGeneralCard.vue';
import CameraPageShootMessageNormal from '@/components/CameraPageShootMessageNormal.vue';
import CameraPageShootCardDiagonalHeader from '@/components/CameraPageShootCardDiagonalHeader.vue';
import IdDocType from '@/resources/enum/IdDocType';

@Component({
  components: {
    SvgDiagonalDriversLicense,
    SvgDiagonalMyNumberCard,
    SvgDiagonalResidenceCard,
    SvgDiagonalSpecialPermanentResidentCertificate,
    SvgDiagonalPassport1,
    SvgDiagonalPassport2,
    SvgDiagonalHealthInsuranceCard,
    CameraPageShootMessageNormal,
    CameraPageShootCardDiagonalHeader,
    SvgDiagonalGeneralCard
  }
})
export default class Parts extends Vue {
  @Prop({ type: Number, required: true })
  public cardWidth!: number;

  @Prop({ type: Number, required: true })
  public cardHeight!: number;

  private get guideTxtType(): string {
    return this.isIdDocPassport ? 'thickness' : 'diagonal';
  }

  private get isIdDocDriversLicense(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.DriversLicenseHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DriversLicenseTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DriversLicenseTi) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DrivingHistoryCertificateHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DrivingHistoryCertificateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.DrivingHistoryCertificateTi) return true;
    return false;
  }

  private get isIdDocMyNumberCard(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.MyNumberCardTi) return true;
    return false;
  }

  private get isIdDocResidenceCard(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.ResidenceCardHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.ResidenceCardTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.ResidenceCardTi) return true;
    return false;
  }

  private get isIdDocSpecialPermanentResidentCertificate(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.SpecialPermanentResidentCertificateHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.SpecialPermanentResidentCertificateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.SpecialPermanentResidentCertificateTi) return true;
    return false;
  }

  private get isIdDocPassport(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.PassportHo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportTi) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.PassportAnyIssuanceDateTi) return true;
    return false;
  }

  private get isIdDocHealthInsuranceCard(): boolean {
    if (this.$store.state.camera.idDocType === IdDocType.HealthInsuranceCardTo) return true;
    if (this.$store.state.camera.idDocType === IdDocType.HealthInsuranceCardTi) return true;
    return false;
  }

  private get isPassport1(): boolean {
    return this.isIdDocPassport && !this.$store.getters['camera/isPC'];
  }

  private get isPassport2(): boolean {
    return this.isIdDocPassport && this.$store.getters['camera/isPC'];
  }

  private get isGeneralCard(): boolean {
    return this.$store.getters['camera/isGeneralCard'];
  }

  private get strokeSize(): number {
    return Math.ceil(this.cardWidth / 100);
  }

  private get cardCalcWidth(): number {
    const maxWidth: number = this.$store.state.camera.clippingDisplayWidth - this.strokeSize * 2;
    return Math.min(maxWidth, this.cardWidth);
  }

  private get cardCalcHeight(): number {
    return this.cardCalcWidth * (this.cardHeight / this.cardWidth);
  }

  private get frameSize(): { x: number; y: number; w: number; h: number } {
    const w: number = this.cardCalcWidth + this.strokeSize * 2;
    const h: number = this.cardCalcHeight + this.strokeSize * 2;
    const x: number = (this.$store.state.camera.displayWidth - w) / 2;
    const y: number = this.$store.state.camera.displayIdDocCenter - h / 2;
    return { x, y, w, h };
  }

  private get styleDriversLicense(): { [key: string]: string } {
    // cardWidthが画面の90%で、svg画像の上底がcardWidthと一致するように縮小
    const top: string = `${this.frameSize.y + this.frameSize.h / 2}px`;
    const width: string = `${this.$store.state.camera.clippingDisplayWidth}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    return {
      top,
      width,
      transform: [
        'translateY(-28%)',
        'translateY(-20%) scale(1.0) translateY(20%)',
        `scaleX(${isMirror ? -1 : 1})`
      ].join(' ')
    };
  }

  private get styleMyNumberCard(): { [key: string]: string } {
    // cardWidthが画面の80%で、svg画像の上底がcardWidthと一致するように縮小
    const top: string = `${this.frameSize.y + this.frameSize.h / 2}px`;
    const width: string = `${this.$store.state.camera.clippingDisplayWidth}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transform: string = `translateY(-28%) scaleX(${isMirror ? -1 : 1})`;
    return { top, width, transform };
  }

  private get styleResidenceCard(): { [key: string]: string } {
    // cardWidthが画面の80%で、svg画像の上底がcardWidthと一致するように縮小
    const top: string = `${this.frameSize.y + this.frameSize.h / 2}px`;
    const width: string = `${this.$store.state.camera.clippingDisplayWidth}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transform: string = `translateY(-28%) scaleX(${isMirror ? -1 : 1})`;
    return { top, width, transform };
  }

  private get stylePassport(): { [key: string]: string } {
    // cardWidthが画面の90%
    // frameSize.h => 背景transparentの高さ
    // cardCalcHeight => 本人確認書類の自体の高さ(Svg時点で上下に少し余白有)
    // frameSize.y => 背景transparentの上部
    // frameSize.h - cardCalcHeight => strokeSize * 2 => 本人確認書類の高さ以外の全体余白
    const top: string = `${(this.frameSize.h - this.cardCalcHeight) / 2 + this.frameSize.y}px`;
    const width: string = `${this.$store.state.camera.clippingDisplayWidth}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transform: string = `scaleX(${isMirror ? -1 : 1})`;
    return { top, width, transform };
  }

  private get styleHealthInsuranceCard(): { [key: string]: string } {
    // cardWidthが画面の80%で、svg画像の上底がcardWidthと一致するように縮小
    const top: string = `${this.frameSize.y + this.frameSize.h / 2}px`;
    const width: string = `${this.$store.state.camera.clippingDisplayWidth}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transform: string = `translateY(-28%) scaleX(${isMirror ? -1 : 1})`;
    return { top, width, transform };
  }

  private get styleGeneralCard(): { [key: string]: string } {
    const top: string = `${this.frameSize.y + this.frameSize.h / 2}px`;
    const width: string = `${this.frameSize.w - this.strokeSize * 2}px`;
    const isMirror: boolean = this.$store.getters['camera/isMirror'];
    const transform: string = `translateY(-50%) scaleX(${isMirror ? -1 : 1})`;
    return { top, width, transform };
  }
}
